var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-ecommerce"}},[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"xl":"12","md":"12"}},[_c('dashboard-stats',{attrs:{"data":_vm.data,"rows":_vm.rows}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }